import { OrderedMap, Record } from 'immutable';
import type { RecordOf } from 'immutable';
import type { FeatureFlagsQLH } from './featureFlagsQLH';
import type { FeatureFlagsSimplifi } from './featureFlagsSimplifi';

export type FeatureFlagsProps = Partial<FeatureFlagsSimplifi & FeatureFlagsQLH>;
export type FeatureFlagsKeys = keyof FeatureFlagsProps;
export type FeatureFlagsValues = FeatureFlagsProps[FeatureFlagsKeys];
export type FeatureFlags = OrderedMap<FeatureFlagsKeys, FeatureFlagsValues>;

export type FeatureFlagsStore = {
  featureFlags: FeatureFlags;
  resourceName: string;
  loadPending: boolean;
  isLoading: boolean;
  error: any;
};

export const mkFeatureFlagsStore = Record<FeatureFlagsStore>({
  featureFlags: OrderedMap(),
  resourceName: 'FEATURE_FLAGS',
  loadPending: true,
  isLoading: false,
  error: undefined,
});

export const FEATURE_FLAGS_REDUCER_KEY = 'featureFlagsStore';

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [FEATURE_FLAGS_REDUCER_KEY]: RecordOf<FeatureFlagsStore>;
  }
}
